import _filter from 'lodash/filter'
import _get from 'lodash/get'
import _merge from 'lodash/merge'

import axios from '../../_framework/axios/trip-dashboard-axios'
import { StoreCollection } from '../../_stores/StoreCollection'

export default _merge({}, StoreCollection, {
  state: {
    collection: _get(window, 'appInitialData.stores.WysiwygTemplates.collection', [])
  },
  getters: {
    templateForTag: state => {
      return tag => {
        return _filter(state.collection, template => {
          return template.tag === tag
        })
      }
    }
  },
  mutations: {
    updateWysiwygTemplates(state, payload) {
      state.collection = payload.templates
    }
  },
  actions: {
    refreshWysiwygTemplates(context) {
      axios.get('/wysiwygTemplates/list').then(response => {
        if (response.status === 200) {
          context.commit('updateWysiwygTemplates', response.data)
        }
      })
    },
    addWysiwygTemplate(context, payload) {
      axios.post('/wysiwygTemplates/create', payload).then(response => {
        if (response.status === 200) {
          context.commit('updateWysiwygTemplates', response.data)
        }
      })
    },
    updateWysiwygTemplate(context, payload) {
      axios.post(`/wysiwygTemplates/${payload.id}/update`, payload.item).then(response => {
        if (response.status === 200) {
          context.commit('updateWysiwygTemplates', response.data)
        }
      })
    },
    removeWysiwygTemplate(context, payload) {
      axios.post(`/wysiwygTemplates/${payload.id}/delete`).then(response => {
        if (response.status === 200) {
          context.commit('updateWysiwygTemplates', response.data)
        }
      })
    }
  }
})
